import { WORLD_SEED_DEFAULT } from "@craftgaming/shared";
import { showMainMenu } from "./ui/main-menu";
import { createGame } from "./core/game";
import { connectToServer, type NetworkSession } from "./network/colyseus-network";
import { showConnectionBanner } from "./ui/connection-banner";

const WS_SCHEME = window.location.protocol === "https:" ? "wss" : "ws";
const SERVER_URL =
  import.meta.env.VITE_SERVER_URL || `${WS_SCHEME}://${window.location.hostname}:2567`;

const canvas = document.getElementById("game-canvas") as HTMLCanvasElement;

if (!canvas) {
  throw new Error("Canvas element #game-canvas not found");
}

async function init() {
  try {
    const { selectedClass, playerName, gameMode } = await showMainMenu();

    // Try multiplayer first; fall back to explicit single-player.
    let network: NetworkSession | null = null;
    let seed = WORLD_SEED_DEFAULT;
    try {
      network = await connectToServer(SERVER_URL, playerName, selectedClass.id);
      seed = network.seed;
      showConnectionBanner("online");
    } catch (err) {
      console.warn("[Network] Could not connect to server, running single-player:", err);
      const cause = err instanceof Error ? err.message.slice(0, 80) : undefined;
      showConnectionBanner("offline", cause);
    }

    const game = createGame(canvas, { classDef: selectedClass, playerName, network, seed, gameMode });
    game.start();

    window.addEventListener("beforeunload", () => {
      game.dispose();
    });
  } catch (err) {
    // Show error on screen for debugging
    const loadingEl = document.getElementById("loading-screen");
    if (loadingEl) {
      loadingEl.innerHTML = `<pre style="color:red;padding:20px;font-size:14px;white-space:pre-wrap;">${err instanceof Error ? err.stack || err.message : String(err)}</pre>`;
    }
    console.error(err);
  }
}

init();
